<!-- The reused footer of questions. -->
<template>
    <footer>
        <p v-if="questionData.descriptionBelow" v-html="DOMPurify.sanitize(questionData.descriptionBelow)"></p>
    </footer>
</template>

<script>
export default {
    name: `question-footer`,
    inject: ['DOMPurify'],
    props: {
        questionData: {
            type: Object,
        },
    },
    computed: {
        state: function () {
            return this.$store.state;
        },
        settings: function () {
            return this.state.settings;
        },
    },
};
</script>

<style scoped>
[question]:not(:last-of-type) footer p:empty {
    display: none;
}

footer {
    background: #fff;
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
    padding: 20px 35px;

    p {
        margin: 0;
        font-size: calc(var(--DescriptionStyling-font-size) * 1px);
        font-family: var(--DescriptionStyling-font-family-public-name);
        color: var(--DescriptionStyling-color);
        width: 100%;
    }

    &:empty {
        padding: 7px;
    }
}
</style>